<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kex23U/tc-custom/9781250233783.jpg?1719549150367" alt="This image is the cover for the book I Needed a Viking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Needed a Viking
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From the author of <i>I Find You In the Darkness, </i>a brand-new book of poetry celebrating strong women and the men they crave</b><br/><br/>I never needed a Man. <br/>I needed a <i>Viking</i>. <br/>I needed someone who wasn't afraid of my strengths or of my needs. <br/>I chose wrong in the past....<br/><br/>Beloved contemporary poet Alfa is back with a brand-new collection of more than 180 heartfelt poems on the theme of woman warriors and the masculine heroes they long for. In gorgeous, compelling, and intimate prose, <i>I Needed a Viking </i>takes us on an emotional journey of a woman searching for strength in the midst of a storm.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alfa
      </h2>
      
      <p class="authorDescription body article">ALFA is a retired medical professional who has spent most of her career in Radiation Therapy. She credits her ability to express painful life experiences by studying the human body from the inside out. Unapologetic about her realistic take on heartache, she writes to let her readers know they are not alone in their pain. Follow her on Instagram</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin's Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?72d2f205